import React, { useState, useEffect } from "react";
import Layout from "../../../Components/Layout/layout";
import dashboardclasses from "../../dashboard.module.css";
import "../../../App.css";
import { useSearchParams } from "react-router-dom";
import VendorInfo from "./VendorInfo";
import Loader from "../../../Components/loader/loader";
import { useNavigate } from "react-router-dom";
import Vendordoc from "./Vendordoc";
import Handler from "./handler";
import Services from "./Services";
import WalletTransactions from "./walletTransactions";
function Warehouse() {
    const Navigate = useNavigate();
    const [params] = useSearchParams();
    const [Navactive, setNavactive] = useState("1");
    const {
        data,
        loading,
        deleteDocData,
        fetchData,
        updateVendorDocs,
        setData,
    } = Handler();

    useEffect(() => {
        fetchData(params.get("id"));
        // eslint-disable-next-line
    }, []);

    const navactivehandler = (e) => {
        let status = e.currentTarget.getAttribute("id");
        setNavactive(status);
    };
    return (
        <>
            <Layout Active={"Vendors"}>
                <div className={dashboardclasses["dashboard-rightside"]}>
                    <div className={dashboardclasses.CategoryWrapper}>
                        <button
                            className={dashboardclasses["backbutton"]}
                            onClick={() => {
                                Navigate(-1);
                            }}>
                            Back
                        </button>
                        <div className={dashboardclasses["add-product"]}>
                            <h3>Vendor Details</h3>
                        </div>
                        {loading ? (
                            <Loader />
                        ) : (
                            <>
                                <div
                                    className={
                                        dashboardclasses["user-details-nav"]
                                    }>
                                    <button
                                        id="1"
                                        className={
                                            Navactive === "1" &&
                                            dashboardclasses["order-active"]
                                        }
                                        onClick={navactivehandler}>
                                        Info
                                    </button>
                                    <button
                                        id="2"
                                        className={
                                            Navactive === "2" &&
                                            dashboardclasses["order-active"]
                                        }
                                        onClick={navactivehandler}>
                                        Documents
                                    </button>
                                    <button
                                        id="3"
                                        className={
                                            Navactive === "3" &&
                                            dashboardclasses["order-active"]
                                        }
                                        onClick={navactivehandler}>
                                        Subcategories
                                    </button>
                                    <button
                                        id="4"
                                        className={
                                            Navactive === "4" &&
                                            dashboardclasses["order-active"]
                                        }
                                        onClick={navactivehandler}>
                                        Wallet Transactions
                                    </button>
                                </div>
                                {Navactive === "1" && (
                                    <VendorInfo user={data.Vendors} />
                                )}
                                {Navactive === "2" && (
                                    <Vendordoc
                                        doc={data.Documents}
                                        info={data.Vendors}
                                        setData={setData}
                                        deleteDocData={deleteDocData}
                                        updateVendorDocs={updateVendorDocs}
                                    />
                                )}
                                {Navactive === "3" && (
                                    <Services Services={data.Subcategories} />
                                )}
                                {Navactive === "4" && (
                                    <WalletTransactions
                                        Services={data.WalletTransactions}
                                    />
                                )}
                            </>
                        )}
                    </div>
                </div>
            </Layout>
        </>
    );
}

export default Warehouse;
